export class RastreamentoService {
  constructor(RastreamentoResource) {
    "ngInject";

    this.resource = RastreamentoResource;
  }

  async getRastreio(item) {
    return this.resource.getRastreio({ idRastreamento: item || null }, item).$promise;
  }

  async putEmailDestinatario(trackNumberEmail) {
    return this.resource.putEmailDestinatario(trackNumberEmail).$promise;
  }

  async getDadosVolumes(item) {
    // return this.resource.getDadosVolumes({ idRastreamento: idRastreamento }).$promise;
    return this.resource.getDadosVolumes({ idRastreamento: item || null }, item).$promise;
  }

  async getComprovanteEntrega(encomenda) {
    return this.resource.getComprovanteEntrega({idEncomenda: encomenda}).$promise;
  }
}
